<template>
  <div class="accordion-item w-100 mb-3 mt-2">
    <div
      class="accordion-header rounded d-flex justify-content-between"
      :id="'heading-' + id"
      :class="[!open && 'bg-gray']"
    >
      <b-button
        :class="[open ? 'w-50' : 'w-100']"
        :data-bs-toggle="'#collapse-' + id"
        :data-bs-target="'#collapse-' + id"
        @click="open = !open"
        class="d-flex justify-content-between align-items-center fw-medium"
        block
        variant="ghost"
      >
        {{ title }}

        <b-icon v-if="!open" variant="primary" icon="chevron-right" />
      </b-button>
      <div v-if="open" class="d-flex align-items-center">
        Selecionar Todos
        <input
          type="checkbox"
          :checked="checked"
          class="cb-subAccordion"
          @click="$emit('selectAll', title)"
        />
      </div>
    </div>
    <b-collapse
      :id="'collapse-' + id"
      class="accordion-collapse collapse"
      :class="{ show: open }"
      :aria-labelledby="'heading-' + id"
      data-bs-parent="#accordion"
      v-model="open"
    >
      <b-card-body class="p-0">
        <slot />
      </b-card-body>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "SubAccordion",
  props: {
    title: {
      type: String,
      require: true,
    },
    id: {
      type: String,
      require: true,
    },
    checked: Boolean,
  },
  data() {
    return {
      open: false,
    };
  },
};
</script>

<style scoped>
.cb-subAccordion {
  height: 1.1rem;
  width: 1.1rem;
  font-size: 1.1rem;
  border-color: #c3cbd9;
  margin-left: 12px;
  margin-right: 15px;
}
</style>
